import { monitoringService, productRecommendationsService } from '../../services';
import { EVENT_VALUES, EVENTS } from '../../constants/noflake/noflakeSchema';

export const attachProductRecListeners = ({ onChange }) => {
  window.addEventListener('message', (message) => {
    const {
      data: {
        productRecommendationsReadyToReceiveMessages,
        productRecommendationsContentLoaded,
        productRecommendationsIframeClickTrackingMessage,
      },
    } = message;

    if (productRecommendationsReadyToReceiveMessages) {
      productRecommendationsService.provideSettings();
      productRecommendationsService.provideContext();
    }

    if (productRecommendationsContentLoaded) {
      onChange(true);
    }

    if (productRecommendationsIframeClickTrackingMessage) {
      monitoringService.postData({
        type: EVENTS.CLICK,
        value: EVENT_VALUES[EVENTS.CLICK].product_recommendations,
      });
    }
  });
};
